import PointHttpClientService from "@/CommonVueCore/src/services/httpService/axios/pointHttpClientService.js";

export class PRApprovalMatrixServiceClient extends PointHttpClientService {
  constructor({ baseUri }) {
    super({
      baseUrl: baseUri,
    });
  }
}
